(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revier-cart"]) return;
  try {
    
if(!customElements.get('revier-cart'))customElements.define('revier-cart',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const form=this.querySelector('form');if(!form)return;let pending=false;
const sync=async()=>{const response=await fetch(window.Shopify.routes.root+'cart.js');if(!response.ok)throw new Error(this.dataset.error);const cart=await response.json();const camera=Number(this.dataset.cameraId);const quantity=cart.items.filter(item=>item.variant_id===camera).reduce((sum,item)=>sum+item.quantity,0);const code=quantity>=4?'REVIERLUMA-PACK4':quantity>=3?'REVIERLUMA-PACK3':quantity>=2?'REVIERLUMA-PACK2':'';const codes=(cart.discount_codes||[]).filter(item=>!item.code.toUpperCase().startsWith('REVIERLUMA-PACK')).map(item=>item.code);if(code)codes.push(code);const result=await fetch(window.Shopify.routes.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(',')})});if(!result.ok)throw new Error(this.dataset.error);};
const submit=async(checkout=false,removeKey=null)=>{if(pending)return;pending=true;const error=this.querySelector('.rl-cart-error');error.hidden=true;const buttons=[...form.querySelectorAll('button')];buttons.forEach(button=>button.disabled=true);try{for(const input of form.querySelectorAll('[data-line-key]')){let quantity=removeKey===input.dataset.lineKey?0:Number(input.value);if(!Number.isInteger(quantity)||quantity<0)throw new Error(this.dataset.error);if(quantity===Number(input.dataset.initial))continue;const response=await fetch(window.Shopify.routes.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:input.dataset.lineKey,quantity})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);}await sync();if(checkout){const hidden=document.createElement('input');hidden.type='hidden';hidden.name='checkout';hidden.value='checkout';form.append(hidden);HTMLFormElement.prototype.submit.call(form);}else window.location.reload();}catch(err){error.textContent=err.message||this.dataset.error;error.hidden=false;pending=false;buttons.forEach(button=>button.disabled=false);}};
this.addEventListener('click',event=>{const step=event.target.closest('[data-qty-step]');if(step){const input=step.parentElement.querySelector('input');input.value=Math.max(0,Number(input.value)+Number(step.dataset.qtyStep));}const remove=event.target.closest('[data-remove-key]');if(remove){event.preventDefault();submit(false,remove.dataset.removeKey);}});form.addEventListener('submit',event=>{event.preventDefault();submit(event.submitter?.name==='checkout');});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revier-contact"]) return;
  try {
    
document.addEventListener('click',function(event){const topic=event.target.closest('[data-contact-topic]');if(!topic)return;const section=topic.closest('.rl-contact');const select=section.querySelector('select[name="contact[Anliegen]"]');if(select)select.value=topic.dataset.contactTopic;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revier-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('revier-home')) {
  customElements.define('revier-home', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rlReady) return;
      this.dataset.rlReady = 'true';
      this.querySelector('.rl-packs')?.removeAttribute('disabled');
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-rl-image]');
        const arrow = event.target.closest('[data-rl-direction]');
        if (!thumb && !arrow) return;
        const buttons = [...this.querySelectorAll('.rl-thumb')];
        let index = buttons.findIndex(item => item.getAttribute('aria-pressed') === 'true');
        index = thumb ? buttons.indexOf(thumb) : (index + Number(arrow.dataset.rlDirection) + buttons.length) % buttons.length;
        const selected = buttons[index];
        if (!selected) return;
        const image = this.querySelector('.rl-featured');
        image.src = selected.dataset.rlImage;
        image.alt = selected.dataset.rlAlt;
        image.removeAttribute('srcset');
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === selected)));
        this.querySelector('.rl-image-count').textContent = `${index + 1} / ${buttons.length}`;
        selected.scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'});
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('.rl-packs input')) return;
        this.querySelector('[data-rl-price]').textContent = event.target.dataset.price;
        this.querySelector('[data-rl-button-price]').textContent = event.target.dataset.price;
      });
      this.addEventListener('submit', async event => {
        const form = event.target.closest('.rl-pack-form');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button[type=submit]');
        if (button.disabled) return;
        const feedback = form.querySelector('.rl-cart-feedback');
        const viewCart = form.querySelector('.rl-view-cart');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        feedback.hidden = true;
        let added = false;
        const root = window.Shopify.routes.root;
        const post = async (path, data) => {
          const response = await fetch(root + path, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
          return result;
        };
        try {
          const quantity = Number(form.querySelector('[name=quantity]:checked').value);
          const id = Number(form.querySelector('[name=id]').value);
          await post('cart/add.js', {items:[{id, quantity}]});
          added = true;
          const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error(this.dataset.addedError);
          const cart = await response.json();
          const totalQuantity = cart.items.filter(item => item.variant_id === id).reduce((sum,item) => sum + item.quantity,0);
          const packCode = totalQuantity >= 4 ? 'REVIERLUMA-PACK4' : totalQuantity >= 3 ? 'REVIERLUMA-PACK3' : totalQuantity >= 2 ? 'REVIERLUMA-PACK2' : '';
          const otherCodes = (cart.discount_codes || []).filter(item => !item.code.toUpperCase().startsWith('REVIERLUMA-PACK')).map(item => item.code);
          if (packCode) otherCodes.push(packCode);
          const updated = await post('cart/update.js', {discount:otherCodes.join(',')});
          if (packCode && !(updated.discount_codes || []).some(item => item.code.toUpperCase() === packCode && item.applicable)) throw new Error(this.dataset.addedError);
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          feedback.textContent = added ? this.dataset.addedError : error.message || this.dataset.error;
          feedback.hidden = false;
          viewCart.hidden = !added;
          if (!added) button.disabled = false;
        } finally { button.removeAttribute('aria-busy'); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
